<ng-container>
  <div class="requisites-container">
    <ng-container *ngFor="let item of requisites">
      <div class="requisites-body">
        <p class="requisites-item"
           *ngIf="item.city"
        >{{item.city}}</p>
        <p class="requisites-item"><strong>{{item.name}}</strong></p>
        <p class="requisites-item"><strong>ИНН:</strong> {{item.inn}}</p>
        <p class="requisites-item"><strong>Юр. адрес:</strong> {{item.legalAddress}}</p>
        <ng-container *ngIf="item.tel">
          <p class="requisites-item" ><strong>Телефон:</strong></p>
          <p class="requisites-item requisites-item_alarm"
             *ngIf="item.telNoteAlarm">
            {{item.telNoteAlarm}}</p>
          <p class="requisites-item">{{item.tel}}</p>
        </ng-container>
        <ng-container *ngIf="item.whatsApp">
          <p class="requisites-item"><strong>WhatsApp:</strong></p>
          <a class="requisites-item requisites-item-link" [href]="item.whatsAppLink">
            {{item.whatsApp}}</a>
        </ng-container>
        <ng-container *ngIf="item.telegram">
          <p class="requisites-item"><strong>Telegram:</strong></p>
          <a class="requisites-item requisites-item-link" [href]="item.telegramLink">
            {{item.telegram}}</a>
        </ng-container>
        <ng-container *ngIf="item.viber">
          <p class="requisites-item"><strong>Viber:</strong></p>
          <p class="requisites-item"
             *ngIf="!item.viberLink"
          >
            {{item.viber}}</p>
          <a class="requisites-item requisites-item-link"
             *ngIf="item.viberLink"
             [href]="item.viberLink">
            {{item.viber}}</a>
        </ng-container>
        <ng-container *ngIf="item.email">
          <p class="requisites-item"><strong>E-mail:</strong></p>
          <p class="requisites-item">{{item.email}}</p>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>

